import React from "react";

export const Fill = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 18"
    >
      <path
        d="M7.296 15c.585 0 1.17-.223 1.615-.668l5.861-5.862a.776.776 0 000-1.098L8.378.978a.776.776 0 00-1.098 0l-5.862 5.86c-.89.89-.89 2.34 0 3.23l4.263 4.263c.445.446 1.03.669 1.615.669zM7.83 2.624l5.296 5.297-.09.09H2.468a.228.228 0 00.02-.033c.008-.014.016-.029.029-.041l5.312-5.313zm8.633 13.126H2.287c-.434 0-.787.336-.787.75s.353.75.788.75h14.174c.435 0 .788-.336.788-.75s-.353-.75-.788-.75zM15.375 15c-1.034 0-1.875-.872-1.875-1.943 0-.864 1.075-2.568 1.405-3.069.208-.317.732-.317.94 0 .33.501 1.405 2.205 1.405 3.069 0 1.071-.841 1.943-1.875 1.943z"
        clipRule="evenodd"
      />
    </svg>
  );
};
